var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"map-card1"},[_c('div',{staticClass:"text-xs-center pt-3 pb-3"},[_vm._v("LIVE MONITORING")]),_c('v-divider',{staticClass:"custom-divider"}),_c('div',{staticClass:"graph-container pa-2"},[_c('GlobalGraph',{staticClass:"graph",attrs:{"series":_vm.series,"xAxisData":_vm.xAxisData,"yAxis":_vm.yAxis,"theme":_vm.theme}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }